var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5171_52566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 16H0.888889C0.397969 16 0 15.602 0 15.1111V0.888889C0 0.397969 0.397969 0 0.888889 0H15.1111C15.602 0 16 0.397969 16 0.888889V15.1111C16 15.602 15.602 16 15.1111 16ZM1.77778 1.77778V14.2222H14.2222V1.77778H1.77778ZM9.77778 12.4444H7.11111V8.88889H6.22222V7.11111H8.88889V10.6667H9.77778V12.4444ZM8.88889 5.33333H7.11111V3.55556H8.88889V5.33333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5171_52566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info_btn.9047a49e98d5dfc3b8941c5a04dfdad0.svg";